<template>
  <div class="identity-picker form-group">
    <label class="identity-picker__label" :for="inputId">{{ $t('OrderPending.identities.label') }}</label>
    <input
      :id="inputId"
      class="form-control"
      type="text"
      autocomplete="off"
      :list="listId"
      :value="value"
      :placeholder="realName"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    >
    <datalist :id="listId">
      <option v-for="name in options" :key="name" :value="name" />
    </datalist>
    <div v-if="isDifferent" class="identity-picker__real">
      <small>{{ $t('OrderPending.identities.realName') }}: {{ realName }}</small>
      <button type="button" class="btn btn-link btn-sm p-0" :disabled="disabled" @click="$emit('input', '')">
        {{ $t('OrderPending.identities.useRealName') }}
      </button>
    </div>
    <regular-checkbox
      v-if="showDefault"
      :checked="isDefault"
      :disabled="disabled"
      :label="$t('OrderPending.identities.useByDefault')"
      @change="$emit('update:isDefault', $event)"
    />
  </div>
</template>

<script>
import regularCheckbox from './regularCheckbox.vue'

export default {
  name: 'identityPicker',

  components: {
    regularCheckbox
  },

  props: {
    realName: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    identities: {
      type: Array,
      default: () => []
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    showDefault: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputId () {
      return `identity-picker-${this._uid}`
    },
    listId () {
      return `identity-picker-list-${this._uid}`
    },
    options () {
      return [...new Set([this.realName, ...this.identities].filter(Boolean))]
    },
    isDifferent () {
      return Boolean(this.value.trim()) && this.value.trim() !== this.realName
    }
  }
}
</script>

<style scoped>
.identity-picker {
  padding: 8px 10px;
  border: 1px dashed #d9dee3;
  border-radius: 6px;
}
.identity-picker__label {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 4px;
}
.identity-picker__real {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  color: #6c757d;
}
</style>
